/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteTagRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'
import {DeleteTagResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'


export const deleteTag = (request: DeleteTagRequest, options?: CashRequestOptions) => post<DeleteTagRequest, DeleteTagResponse>("/2.0/cash/delete-tag", request, {...options, rejectOnError: true })